import React, { Component } from "react";

export class WipeIndicator extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    render() {
        return (
			<div className="WipeIndicator" style={{left: this.props.pos*8, top: 0, position:'absolute', height: this.props.height}}>
			</div>
        );
    }
}

export default WipeIndicator;
